"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionsEventsViewCols = exports.sessionsViewCols = void 0;
exports.sessionsTableColsWithOptions = sessionsTableColsWithOptions;
const typeHelpers_1 = require("./typeHelpers");
exports.sessionsViewCols = [
    { name: "⭐️", id: "bookmarked", type: "boolean", internal: "s.bookmarked" },
    {
        name: "ID",
        id: "id",
        type: "string",
        internal: 's."id"',
    },
    {
        name: "User IDs",
        id: "userIds",
        type: "arrayOptions",
        internal: 't."userIds"',
        options: [], // to be filled in at runtime
        nullable: true,
    },
    {
        name: "Environment",
        id: "environment",
        type: "stringOptions",
        internal: 't."environment"',
        options: [], // to be filled in at runtime
        nullable: true,
    },
    {
        name: "Session Duration (s)",
        id: "sessionDuration",
        type: "number",
        internal: 'o."sessionDuration"',
    },
    {
        name: "Created At",
        id: "createdAt",
        type: "datetime",
        internal: 's."created_at"',
    },
    {
        name: "Traces Count",
        id: "countTraces",
        type: "number",
        step: 1,
        internal: 't."countTraces"',
    },
    {
        name: "Input Cost ($)",
        id: "inputCost",
        type: "number",
        internal: 'o."inputCost"',
    },
    {
        name: "Output Cost ($)",
        id: "outputCost",
        type: "number",
        internal: 'o."outputCost"',
    },
    {
        name: "Total Cost ($)",
        id: "totalCost",
        type: "number",
        internal: 'o."totalCost"',
    },
    {
        name: "Input Tokens",
        id: "inputTokens",
        type: "number",
        step: 1,
        internal: 'o."promptTokens"',
    },
    {
        name: "Output Tokens",
        id: "outputTokens",
        type: "number",
        step: 1,
        internal: 'o."completionTokens"',
    },
    {
        name: "Total Tokens",
        id: "totalTokens",
        type: "number",
        step: 1,
        internal: 'o."totalTokens"',
    },
    {
        name: "Usage",
        id: "usage",
        type: "number",
        step: 1,
        internal: 'o."totalTokens"',
    },
    {
        name: "Trace Tags",
        id: "tags",
        type: "arrayOptions",
        internal: 't."tags"',
        options: [], // to be filled in at runtime
    },
    {
        name: "Scores (numeric)",
        id: "scores_avg",
        type: "numberObject",
        internal: "scores",
    },
    {
        name: "Scores (categorical)",
        id: "score_categories",
        type: "categoryOptions",
        internal: "score_categories",
        options: [], // to be added at runtime
        nullable: true,
    },
    {
        name: "Scores (boolean)",
        id: "score_booleans",
        type: "booleanObject",
        internal: "score_booleans",
        nullable: true,
    },
    {
        name: "Comment Count",
        id: "commentCount",
        type: "number",
        step: 1,
        internal: "", // handled by comment filter helpers
    },
    {
        name: "Comment Content",
        id: "commentContent",
        type: "string",
        internal: "", // handled by comment filter helpers
    },
];
exports.sessionsEventsViewCols = exports.sessionsViewCols.concat({
    name: "Available Tool Names",
    id: "toolNames",
    type: "arrayOptions",
    internal: "st.tool_names",
    options: [],
}, {
    name: "Called Tool Names",
    id: "calledToolNames",
    type: "arrayOptions",
    internal: "st.called_tool_names",
    options: [],
}, {
    name: "Tool Calls",
    id: "toolCalls",
    type: "number",
    step: 1,
    internal: "st.tool_calls_count",
}, {
    name: "Metadata",
    id: "metadata",
    type: "stringObject",
    internal: 's."metadata"',
});
function sessionsTableColsWithOptions(options) {
    return exports.sessionsViewCols.map((col) => {
        if (col.id === "userIds") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.userIds ?? []);
        }
        if (col.id === "environment") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.environment ?? []);
        }
        if (col.id === "tags") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.tags ?? []);
        }
        if (col.id === "scores_avg") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.scores_avg ?? []);
        }
        if (col.id === "score_categories") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.score_categories ?? []);
        }
        if (col.id === "score_booleans") {
            return (0, typeHelpers_1.formatColumnOptions)(col, options?.score_booleans ?? []);
        }
        return col;
    });
}
